// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"595":"c22ed7a2","841":"dc7eecfe"}[chunkId] + ".chunk.js";
};